<p-toast></p-toast>

<main class="first-run">
    <section class="workspace-head">
        <div>
            <p-tag value="30-day trial" severity="success"></p-tag>
            <h1>Workspace is ready</h1>
            <p>{{ workspace()?.activationSummary || 'All modules are available for your trial.' }}</p>
        </div>
        <div class="head-actions">
            <button pButton type="button" icon="pi pi-chart-line" label="Dashboard"
                    (click)="openRoute(workspace()?.dashboardRoute || '/dashboard')"></button>
            <button pButton type="button" icon="pi pi-truck" label="Create Shipment"
                    severity="secondary" (click)="openRoute('/shipment/create')"></button>
        </div>
    </section>

    <section class="progress-band">
        <div>
            <span>Setup progress</span>
            <strong>{{ workspace()?.completedCount || 0 }} / {{ workspace()?.totalCount || 0 }}</strong>
        </div>
        <p-progressBar [value]="completionPercent()" [showValue]="true"></p-progressBar>
    </section>

    @if (provisioning()) {
        <section class="provisioning-band">
            <div>
                <p-tag value="ERP setup ready" severity="success"></p-tag>
                <h2>{{ provisioning()?.businessType?.replaceAll('_', ' ') }}</h2>
                <p>Master data, workflow defaults, role presets, and logistics templates are ready for first use.</p>
            </div>
            <div class="seeded-areas">
                @for (area of provisioning()?.seededAreas || []; track area) {
                    <span>{{ area.replaceAll('-', ' ') }}</span>
                }
            </div>
            @if ((provisioning()?.warnings || []).length) {
                <div class="provisioning-warnings">
                    @for (warning of provisioning()?.warnings || []; track warning) {
                        <span>{{ warning }}</span>
                    }
                </div>
            }
        </section>
    }

    @if (loading()) {
        <section class="empty-state">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Loading workspace</span>
        </section>
    } @else {
        <section class="workspace-grid">
            <div class="checklist-panel">
                <div class="section-title">
                    <h2>First run checklist</h2>
                    <span>Activation outcomes update this automatically.</span>
                </div>

                <div class="checklist">
                    @for (item of checklist(); track item.itemKey) {
                        <article class="checklist-row" [class.completed]="isCompleted(item)" [class.skipped]="item.status === 'SKIPPED'">
                            <div class="check-icon">
                                <i [class]="itemIcon(item)"></i>
                            </div>
                            <div class="check-copy">
                                <strong>{{ item.title }}</strong>
                                <span>{{ item.description }}</span>
                            </div>
                            <div class="check-actions">
                                <button pButton type="button" [icon]="isCompleted(item) ? 'pi pi-check' : 'pi pi-arrow-right'"
                                        [label]="item.actionLabel" size="small" severity="secondary"
                                        [disabled]="isClosed(item)" (click)="openRoute(item.actionRoute)"></button>
                                @if (!isClosed(item)) {
                                    <button pButton type="button" icon="pi pi-check" size="small" text
                                            [loading]="isUpdating(item)" (click)="markDone(item)"></button>
                                    <button pButton type="button" label="Skip for now" size="small" text
                                            [loading]="isUpdating(item)" (click)="skipItem(item)"></button>
                                }
                            </div>
                        </article>
                    }
                </div>
            </div>

            <aside class="templates-panel">
                <div class="section-title">
                    <h2>Templates</h2>
                    <span>Start with logistics-ready defaults.</span>
                </div>

                <div class="template-list">
                    @for (template of templates(); track template.templateKey) {
                        <article class="template-row">
                            <div>
                                <strong>{{ template.title }}</strong>
                                <span>{{ template.description }}</span>
                            </div>
                            <button pButton type="button" icon="pi pi-arrow-right" [label]="template.actionLabel"
                                    size="small" text (click)="openRoute(template.actionRoute)"></button>
                        </article>
                    }
                </div>
            </aside>
        </section>
    }
</main>
